import React, { useState, useEffect } from "react";
import MaterialTable from "components/Table/MaterialTable";
import ListboxWtdOrgtype from "components/Common/ListboxWtdOrgtype";
import {
  getwtdOrg,
  getwtdOrgType,
  editwtdOrg,
  addwtdOrg,
  deletewtdOrg
} from "contexts/API/WTD/common";
import { useSweetAlert } from "components/Alert/SweetAlert";

const Org = props => {
  const { sweetAlerts } = useSweetAlert();
  const [data, setData] = useState([]);
  const [orgTypeList, setOrgTypeList] = useState([]);
  const optionsTable = { pageSize: 10 };
  useEffect(() => {
    getwtdOrgType()
      .then(r => {
        let OrgData = r.data.data.map(v => {
          return { id: v.wtdOrgTypeId, value: v.detail };
        });
        setOrgTypeList(OrgData);
      })
      .catch(err => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "wtdOrgId",
      field: "wtdOrgId",
      hidden: true
    },
    {
      title: "ประเภทหน่วยงาน",
      field: "wtdOrgTypeId",
      cellStyle: {
        minWidth: "300px"
      },
      render: rowData => {
        const v = orgTypeList.find(e => e.id === rowData.wtdOrgTypeId);
        return v !== undefined ? v.value : "";
      },

      editComponent: props => {
        return (
          <ListboxWtdOrgtype
            rowId={0}
            defaultValue={{ id: props.value }}
            data={orgTypeList}
            onChange={(i, e, v) => {
              console.log(e.id);
              if (v !== null) {
                props.rowData.wtdOrgTypeId = e.id;
              }
            }}
          />
        );
      }
    },

    { 
      title: "หน่วยงาน", 
      field: "orgName" , 
      cellStyle: {
        minWidth: "500px"
      }
    }
  ];

  useEffect(() => {
    getwtdOrg()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MaterialTable
      title={"จัดการหน่วยงานที่ออกคำสั่งเพิกถอนสิทธิเลือกตั้ง"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
              addwtdOrg(newData.wtdOrgTypeId, newData.orgName)
                .then(result => {
                  newData.wtdOrgId = result.data.data.wtdOrgId;
                  setData([...data, newData]);
                  sweetAlerts.success("เพิ่มข้อมูลเรียบร้อยแล้ว");
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถเพิ่มข้อมูลได้", err.toString());
                });

              resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
              const dataUpdate = [...data];
              const index = oldData.tableData.id;
              dataUpdate[index] = newData;
              
              editwtdOrg(
                newData.wtdOrgId,
                newData.wtdOrgTypeId,
                newData.orgName
              )
                .then(result => {
                  dataUpdate[index] = newData;
                  setData([...dataUpdate]);
                  
                  sweetAlerts.success("แก้ไขข้อมูลเรียบร้อยแล้ว");
                })
                .catch(err => {
                  const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                  sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
                });
              resolve();
            
          }),
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
              const dataDelete = [...data];
              const index = oldData.tableData.id;
              //console.log("oldData.wtdOrgId>>",oldData.wtdOrgId);
              dataDelete.splice(index, 1);
              deletewtdOrg(oldData.wtdOrgId)
                .then(result => {
                  sweetAlerts.success("ลบข้อมูลเรียบร้อยแล้ว");
                  setData([...dataDelete]);
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถลบข้อมูลได้", err.toString());
                });

              resolve();
          })
      }}
    />
  );
};
export default Org;
